import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import GrunnbokrapportIcon from '../../../images/Grunnboksrapport.png'
import HistoriskGrunnbokrapportIcon from '../../../images/Historisk grunnbok.png'

import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'
import WarningIcon from '../../../images/advarsel2.png'

class Borett extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleBorett = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateEier = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Eier",
            eier: this.props.borett
        })
    }

    downloadKartverketGrunnbok = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/registerenhet/${this.props.borett.registerenhetId}/grunnbokrapport?token=${this.props.token}`
        window.open(url, '_blank')
    }

    downloadKartverketHistoriskGrunnbok = (event) => {
        event.stopPropagation()

        var url = `${this.props.settings.baseUrl}api/registerenhet/${this.props.borett.registerenhetId}/grunnbokhistorikkrapport?token=${this.props.token}`
        window.open(url, '_blank')
    }

    render() {
        const { t } = this.props
        var borett = this.props.borett
        var matrikkelnummer = `${borett.gardsnummer}/${borett.bruksnummer}`;
        if (borett.festenummer || borett.seksjonsnummer) matrikkelnummer += `/${borett.festenummer}/${borett.seksjonsnummer}`;
        var andel = borett.nevner > 0 ? `${borett.teller}/${borett.nevner}` : null;
        var adresse = `${borett.adressenavn||''} ${borett.nummer||''}${borett.bokstav||''}`.trim()

        var titleList = []
        if (adresse) titleList.push(adresse)
        if (borett.bolignummer) titleList.push(borett.bolignummer)
        if (andel) titleList.push(andel)
        if (borett.borettslagAndelsnummer != null) titleList.push(`Andel ${borett.borettslagAndelsnummer}`)

        var infoList = []

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleBorett}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{titleList.join(' - ')}</span>
                    { infoList.length > 0 &&
                    <div className="icon-image tooltip warning">
                        <img src={WarningIcon} />
                        <div className="tooltip-content">
                            {infoList.map((i, index) => { return (<div key={index}>{i}</div>) })}
                        </div>
                    </div> }

                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    { borett.eierId &&
                    <div className="icon-image right tooltip" onClick={this.navigateEier}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.eier')}</div>
                    </div>}
                    <div className="icon-image right tooltip" onClick={this.downloadKartverketHistoriskGrunnbok}>
                        <img className="tool" src={HistoriskGrunnbokrapportIcon} />
                        <div className="tooltip-content">{t('historiskgrunnboksrapport')}
                            { this.props.seksjonsnummer > 0 && <div>{t('seksjon')}</div> }
                            { this.props.erFramfeste && this.props.seksjonsnummer == 0 && <div>{t('framfeste')}</div> }
                        </div>
                    </div>
                    { !this.props.utgatt &&
                    <div className="icon-image right tooltip" onClick={this.downloadKartverketGrunnbok}>
                        <img className="tool" src={GrunnbokrapportIcon} />
                        <div className="tooltip-content">{t('grunnboksrapport')}
                            { this.props.seksjonsnummer > 0 && <div>{t('seksjon')}</div> }
                            { this.props.erFramfeste  && this.props.seksjonsnummer == 0 && <div>{t('framfeste')}</div> }
                        </div>
                    </div> }

                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                <div className="row">
                        <div className="column">
                            <div className="label">{t('navn')}</div>
                            <div className="value">{borett.eiernavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{borett.eierDomeneklasse == "JuridiskPerson" ? t('orgnummer') : t('fodselsnummer')}</div>
                            <div className="value">{borett.eiernummer}</div>
                        </div>
                    </div>
                    <div className="row">
                    <div className="column">
                            <div className="label">{t('bolignummer')}</div>
                            <div className="value">{borett.bolignummer}</div>
                        </div>

                        <div className="column">
                            <div className="label">{t('borettslagandelsnummer')}</div>
                            <div className="value">{borett.borettslagAndelsnummer}</div>
                        </div>
                    </div>

                    <div className="row">
                    <div className="column">
                            <div className="label">{t('adresse')}</div>
                            <div className="value">{adresse}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('poststed')}</div>
                            <div className="value">{borett.postnummer} {borett.poststed}</div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="column">
                            <div className="label">{t('andel')}</div>
                            <div className="value">{borett.teller}/{borett.nevner}</div>
                        </div>
                    </div>                    
                    
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('borettslag')}</div>
                            <div className="value">{borett.borettslagNavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('orgnummer')}</div>
                            <div className="value">{borett.borettslagOrganisasjonsnummer}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Borett)